import { Alpine } from '../core/alpine-core.js';

const IFRAME_SRC = '/venue-kiosk/quick-match?adminEmbed=1';

Alpine.data('adminQuickMatchPage', () => ({
  iframeKey: 0,
  loading: true,
  loadError: '',

  init() {
    this._onMessage = (ev) => this.onEmbedMessage(ev);
    globalThis.addEventListener('message', this._onMessage);
    this._loadTimer = globalThis.setTimeout(() => {
      if (this.loading) {
        this.loading = false;
        this.loadError = this.loadError || 'Quick Match is taking longer than expected. Try refresh below.';
      }
    }, 12000);
  },

  destroy() {
    if (this._onMessage) {
      globalThis.removeEventListener('message', this._onMessage);
    }
    if (this._loadTimer) {
      globalThis.clearTimeout(this._loadTimer);
      this._loadTimer = null;
    }
  },

  get iframeSrc() {
    const v = Number(this.iframeKey) || 0;
    return v > 0 ? `${IFRAME_SRC}&_aq=${v}` : IFRAME_SRC;
  },

  onIframeLoad() {
    this.loading = false;
    this.loadError = '';
    if (this._loadTimer) {
      globalThis.clearTimeout(this._loadTimer);
      this._loadTimer = null;
    }
  },

  reloadIframe() {
    this.loading = true;
    this.loadError = '';
    this.iframeKey = (Number(this.iframeKey) || 0) + 1;
    if (this._loadTimer) globalThis.clearTimeout(this._loadTimer);
    this._loadTimer = globalThis.setTimeout(() => {
      if (this.loading) {
        this.loading = false;
        this.loadError = 'Could not load Quick Match. Check that the cloud API is running and refresh.';
      }
    }, 12000);
  },

  onEmbedMessage(ev) {
    try {
      if (!ev?.origin || ev.origin !== globalThis.location.origin) return;
    } catch {
      return;
    }
    const d = ev.data;
    if (!d || typeof d !== 'object' || d.source !== 'darts-venue-kiosk' || !d.adminEmbed) return;
    if (d.type === 'ready') {
      this.loading = false;
      this.loadError = '';
      if (this._loadTimer) {
        globalThis.clearTimeout(this._loadTimer);
        this._loadTimer = null;
      }
      return;
    }
    if (d.type === 'reset' || d.type === 'close') {
      this.reloadIframe();
    }
  },
}));
